import type { FlowScreenConfig } from "@/shared/constants/flowTypes";
import { MilitaryDetails, validateMilitaryDetails } from "../components/MilitaryDetails";

export function createMilitaryScreens(firstName: string): FlowScreenConfig[] {
  return [
    {
      id: "military_service",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: `Did ${firstName} serve in the military?`,
      subtitle: "Veterans may be eligible for burial benefits, survivor benefits, and VA programs.",
      question: {
        type: "multiple_choice",
        required: true,
        options: [
          { value: "yes", label: "Yes, they were a veteran" },
          { value: "no", label: "No military service" },
          { value: "not_sure", label: "I'm not sure" },
        ],
      },
    },
    {
      id: "military_details",
      layout: "full",
      textAlign: "center",
      maxWidth: "2xl",
      title: "Military service details",
      subtitle: "Add what you know. We'll help you gather details later.",
      hideButton: true,
      customComponent: MilitaryDetails,
      validate: validateMilitaryDetails,
      shouldDisplay: ({ answers }) => answers["military_service"] === "yes",
    },
  ];
}
